module.exports = __webpack_public_path__ + "static/img/special.90b0ae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/special.png
// module id = s4uK
// module chunks = 2